module.exports = __webpack_public_path__ + "img/zlindex5.0cd2dedb.png";